import React, { useRef, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import Button from './Button';
import { Eraser } from 'lucide-react';

interface SignatureCaptureProps {
  onSave: (signatureDataUrl: string) => void;
  onClear?: () => void;
  disabled?: boolean;
  error?: string;
}

export const SignatureCapture: React.FC<SignatureCaptureProps> = ({
  onSave,
  onClear,
  disabled = false,
  error
}) => {
  const sigCanvas = useRef<SignatureCanvas>(null);
  const [isEmpty, setIsEmpty] = useState(true);

  const handleClear = () => {
    sigCanvas.current?.clear();
    setIsEmpty(true);
    onClear?.();
  };

  const handleEnd = () => {
    const canvasIsEmpty = sigCanvas.current?.isEmpty() ?? true;
    setIsEmpty(canvasIsEmpty);
    
    // Auto-save when signature is drawn
    if (!canvasIsEmpty && sigCanvas.current) {
      const dataUrl = sigCanvas.current.toDataURL('image/png');
      onSave(dataUrl);
    }
  };

  return (
    <div className="space-y-3">
      <label className="block text-sm font-medium">
        Signature <span className="text-red-500">*</span>
      </label>
      <div className="border-2 border-gray-300 rounded-lg overflow-hidden bg-white">
        <SignatureCanvas
          ref={sigCanvas}
          canvasProps={{
            className: 'w-full h-40 touch-none',
            style: { touchAction: 'none' }
          }}
          onEnd={handleEnd}
        />
      </div>
      {error && <p className="text-sm text-red-600">{error}</p>}
      <div className="flex gap-2">
        <Button
          type="button"
          onClick={handleClear}
          disabled={disabled || isEmpty}
          icon={Eraser}
          className="flex-1"
        >
          Clear Signature
        </Button>
      </div>
      <p className="text-xs text-gray-500">
        Please sign in the box above using your mouse or touch screen
      </p>
    </div>
  );
};

export default SignatureCapture;
